import { render } from "./CampaignResultsComponent.vue?vue&type=template&id=05efca4d"
import script from "./CampaignResultsComponent.vue?vue&type=script&lang=js"
export * from "./CampaignResultsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__